import React from 'react'
import styles from './ProductCardSkeleton.module.scss'
import Box from '@/components/UI/box/Box'
import Divider from '@/components/UI/divider/Divider'
import Skeleton from '@/components/UI/skeleton/Skeleton'

const ProductCardSkeleton = () => {
  return (
    <Box className={styles['skeleton-container']}>
      <Box className={styles['image-skeleton']}>
        <Skeleton variant="rectangular" height={240} />
      </Box>
      <Box className={styles['title-skeleton']}>
        <Skeleton variant="text" width={50} height={20} />
      </Box>
      <Box className={styles['title-skeleton']}>
        <Skeleton variant="text" width={250} height={20} />
      </Box>
      <Box className={styles['description-skeleton']}>
        <Skeleton variant="text" width={180} height={20} />
        <Divider orientation="vertical" />
        <Skeleton variant="text" width={80} height={20} />
      </Box>
      <Box className={styles['pricing-rating-section']}>
        <Box className={styles['pricing-section']}>
          <Skeleton variant="text" width={150} height={30} />
        </Box>
      </Box>
    </Box>
  )
}

export default ProductCardSkeleton
